import {
  CONFIRMED_GET_MONTHLY_TARGET,
  CONFIRMED_SAVE_MONTHLY_TARGET,
  CONFIRMED_DELETE_MONTHLY_TARGET,
} from "../types/MonthlyTargetTypes";

const initialState = {
  list: [],
};

export default function MonthlyTargetReducer(state = initialState, action) {
  switch (action.type) {
    case CONFIRMED_GET_MONTHLY_TARGET:
      return {
        ...state,
        list: action.payload,
      };

      case CONFIRMED_SAVE_MONTHLY_TARGET:
        return state;
        
    case CONFIRMED_DELETE_MONTHLY_TARGET:
      return {
        ...state,
        list: state.list.filter(
          (item) => item.target_id !== action.payload
        ),
      };

    default:
      return state;
  }
}
